import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { KatSpinner } from "@amzn/katal-react";

import AppInitWrapper from "./AppInitWrapper";
import store from "./store/store";

import "./i18n";
import "./index.scss";
import { Init } from "src/config/auth";
import { setReturnToUrl } from "./utils/userDeeplink";
// lazy loading App allows React Suspense to kick in while app is being loaded
const App = React.lazy(() => import("src/App"));

setReturnToUrl();
Init();

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <AppInitWrapper>
          <React.Suspense fallback={<KatSpinner size="large" />}>
            <App />
          </React.Suspense>
        </AppInitWrapper>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
